import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useInfiniteQuotes } from '../hooks/useQuotes'
import { useTags } from '../hooks/useTags'
import { QuoteList } from '../components/QuoteList'

export const TagDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const tagId = Number(id)
  const sentinelRef = useRef<HTMLDivElement>(null)

  const { data: tags } = useTags()
  const tag = tags?.find((t) => t.id === tagId)

  const { data, isLoading, error, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuotes(20, tagId)
  const quotes = data?.pages.flatMap((page) => page.items) ?? []

  useEffect(() => {
    const sentinel = sentinelRef.current
    if (!sentinel) return
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage()
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [hasNextPage, isFetchingNextPage, fetchNextPage])

  return (
    <div>
      <h2>#{tag?.name ?? `Tag ${id}`}</h2>
      <QuoteList
        quotes={quotes}
        isLoading={isLoading}
        error={error}
        isFetchingNextPage={isFetchingNextPage}
      />
      <div ref={sentinelRef} style={{ height: '1px' }} />
    </div>
  )
}
